<template>
  <div>
    <CCard></CCard>
    <CRow>
      <CCol md="12">
        <CCard>
          <CCardHeader>
            <div class="flex">
              <h1>Użytkownicy</h1>
            </div>
          </CCardHeader>
          <CCardBody>
            <CRow>
              <CCol sm="12">
                 <div md="12">
                  <input
                    id="searchInput"
                    v-model="searchValue"
                    @change="mthSearch()"
                    type="text"
                    placeholder="Wyszukiwarka"
                  />
                </div>
                <CRow>
                  <CCol sm="12">
                    <table class="table">
                      <thead>
                        <tr>
                          <th scope="col">Id</th>
                          <th scope="col">Użytkownik</th>
                          <th scope="col">Firma</th>
                          <th scope="col">Typ</th>
                          <th scope="col">Aktywny</th>
                          <th></th>
                        </tr>
                      </thead>
                      <tbody>
                        <tr
                          @click="mthGoToEdit(item.id)"
                          class="B2BproductRow"
                          v-for="(item,index) in datamain"
                          v-bind:key="item.id"
                        >
                          <td>{{item.id}}</td>
                          <td>{{item.login}}</td>
                          <td>{{JSON.parse(item.extras).nazwafirmy}}</td>
                          <td>{{item.typ | usertypeinttostring}}</td>
                          <td>{{item.active | myfzeroniejedentak}}</td>
                         
                        </tr>
                      </tbody>
                    </table>
                  </CCol>
                </CRow>
              </CCol>
            </CRow>
          </CCardBody>
        </CCard>
      </CCol>
    </CRow>
  </div>
</template>
<script>
import { freeSet } from "@coreui/icons";

export default {
  name: "b2bsalesrepresentatives",
  freeSet,
  created() {
    this.mthFillData();
  },
  directives: {
    focus: {
      // directive definition
      inserted: function (el) {
        el.focus();
      },
    },
  },
  data() {
    return {
      searchValue: "",
      editindex: -1,
      newfirstname: "",
      datamain: [],
    };
  },
  methods: {
    mthSearch(){
      this.mthFillData(this.searchValue);
    },
    mthGoToEdit(id){
      this.$router.replace("/b2buserDetails/" + id);
    },
    mthFillData() {
      var apiurl =
        process.env.VUE_APP_API_URL + "/b2bstar?a=user&type=nodeletefield&limit=100&search="+encodeURIComponent(this.searchValue)+"&searchfields=login,extras";

      var that = this;

      this.$axios({
        method: "get",
        url: apiurl,
      })
        .then(function (response) {
          //console.log("api response:");
          console.log(response.data);
          that.datamain = response.data;
        })
        .catch(function (error) {
          console.log(error);
          that.loginsuccess = false;
          that.loginresultmsg = "Brak połączenia z API (" + error + ").";
        });
    },
  },
};
</script>

<style scoped>
input{margin-bottom: 3px;}
.flex {
  display: flex;
  justify-content: space-between;
}
</style>